import { render, staticRenderFns } from "./MecanizadoHistoryRegistra.vue?vue&type=template&id=08f9c9a6&"
import script from "./MecanizadoHistoryRegistra.vue?vue&type=script&lang=js&"
export * from "./MecanizadoHistoryRegistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports